import React, { createContext, useContext, useState, useEffect } from 'react';
import { getProfile } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('chartaudit_token');
    const savedUser = localStorage.getItem('chartaudit_user');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      // Verify token is still valid
      getProfile().then(res => {
        setUser(res.data);
        localStorage.setItem('chartaudit_user', JSON.stringify(res.data));
      }).catch(() => {
        localStorage.removeItem('chartaudit_token');
        localStorage.removeItem('chartaudit_user');
        setUser(null);
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const loginUser = (token, userData) => {
    localStorage.setItem('chartaudit_token', token);
    localStorage.setItem('chartaudit_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('chartaudit_token');
    localStorage.removeItem('chartaudit_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
